import React from 'react';
import type TTab from './types/TTab';
import Box from '../Box/Box';
import { TextLarge } from '../Text';
import { isEnterOrSpace } from '../../utils/keyboard';

function getModifier(isActive?: boolean, orientation?: string): string[] {
  const modifiers = [] as string[];
  if (isActive) modifiers.push('active');
  if (orientation) modifiers.push(orientation);
  return modifiers;
}

function calcTextType(isActive?: boolean): 'strong' | 'span' {
  return isActive ? 'strong' : 'span';
}

function makeKeyDownHandler(onClick?: () => void) {
  return (event: React.KeyboardEvent) => {
    if (!isEnterOrSpace(event.key)) return;
    event.preventDefault();
    onClick?.();
  };
}

const Tab = ({ label, onClick, isActive, id, badge, orientation, ...otherProps }: TTab) => {
  return (
    <Box
      as="button"
      name="TabNextButton"
      onClick={onClick}
      onKeyDown={makeKeyDownHandler(onClick)}
      modifiers={getModifier(isActive)}
      role="tab"
      aria-selected={isActive}
      aria-controls={`tab-${id}`}
      id={`tab-${id}`}
      {...otherProps}
    >
      <Box as="div" name="TabNext" modifiers={getModifier(isActive, orientation)}>
        <TextLarge as={calcTextType(isActive)}>{label}</TextLarge>
        {badge && badge}
      </Box>
    </Box>
  );
};

export default Tab;
